/**
 * Money is stored as `Decimal(12, 2)` and arrives in JavaScript as floats, so
 * adding payments the obvious way gives 1200.0000000000002 and a balance of
 * 1e-13 — shown as a red "$0.00". Sum in whole cents and round the result.
 */
/** Below this, an amount is nothing: half a cent, the precision money is kept at. */
export const MONEY_EPSILON = 0.005;
/** An amount in whole cents. */
export function toCents(amount) {
    return Math.round(amount * 100);
}
/** An amount rounded to the cent. */
export function roundMoney(amount) {
    return toCents(amount) / 100;
}
/** The sum of amounts, added in cents so the result is exact to the cent. */
export function sumMoney(amounts) {
    let cents = 0;
    for (const amount of amounts)
        cents += toCents(amount);
    return cents / 100;
}
/** Whether an amount is more than nothing — the one test for "still owed". */
export function isPositiveAmount(amount) {
    return amount > MONEY_EPSILON;
}
/**
 * A quantity times a price, rounded to the cent. Multiplied in cents so a
 * half-cent result rounds up as written: 0.30 × 3.35 is 1.005, which as floats
 * is 1.00499… and would otherwise round down.
 */
export function multiplyMoney(quantity, price) {
    return Math.round((toCents(quantity) * toCents(price)) / 100) / 100;
}
//# sourceMappingURL=money.js.map